import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(() => ({
  dropdownContainer: {
    position: 'relative',

  },
  dropdown: {
    '& .MuiAutocomplete-inputRoot': {
      backgroundColor: '#f7f7f7',
      height: '48px',
      borderRadius: '5px',
      padding: '0 16px',
      paddingRight: '40px',
      marginBottom: '6px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiAutocomplete-popupIndicator': {
      marginRight: '8px',
      cursor: 'pointer',
    },
  },
  listBox: {
    padding: '0px',
    margin: '0px',
    borderRadius: '5px',
    '& .MuiAutocomplete-groupLabel': {
      top: '0',
    },
    '& li': {
      margin: '0px',
      padding: '0px !important',
      '& ul li': {
        padding: '10px 0px 10px 0px !important',
      },
      '& .MuiListSubheader-root': {
        padding: '4px 8px',
        margin: '0px',
        fontWeight: 600,
        fontSize: '13px',
        height: '40px',
        backgroundColor: '#f7f7f7',
        lineHeight: '30px',
        borderBottom: '1px solid #f0f0f0',
        borderTop: '1px solid #f0f0f0',
      },
    },
  },

  placeholder: {
    color: '#34343473',
    fontWeight: 400,
  },
}), { name: 'PurposePaymentDropdown' });
export default useStyles;
